<template>
  <div class="modal-overlay-login-card-select">

    <div class="modal-content">

      <div class="dashboard">

        <span class="close-button" @click="closeRegisteredCardModal">&times;</span>

        <h2>選擇卡片折抵</h2>
        <!-- <p class="subtitle">使用您的紅利折抵卡片扣抵停車機費</p> -->
        <!-- Registered Cards Container -->
        <div class="registered-cards">
          <div v-if="registered_cards.length === 0" class="no-cards">
            No registered credit cards found.
          </div>

          <div class="cards-container">
            <!-- "+" Card to Open Modal -->
            <div class="card add-card" @click="openModal">
              <div class="add-icon">+</div>
              <div class="add-text">新增卡片</div>
            </div>
            <div class='card-dashboard'>

              <!-- Registered Credit Cards -->
              <div v-for="card in registered_cards" :key="card.id" class="card registered-card">
                <div class="card-content">
                  <div class="card-image">
                    <img :src="getOfferCardImageURL(card.offer_card_id)"
                      :alt="`${capitalizeFirstLetter(card.card_type)} Image`" />
                  </div>
                  <div class="card-details">
                    <p class="bank-info">{{ card.bank }} | {{ card.name }}</p>
                    <p class="card-number">{{ maskCardNumber(card.card_number) }}</p>
                    <p class="status">
                      <img src="@/assets/icon_success.png" alt="success" class="status-icon" /> 已登記紅利折抵
                    </p>
                  </div>
                  <!-- <button class="delete-button" @click="attempRemoveRegisteredCard(card.id, card.card_type, card.card_number)">
              <img src="@/assets/delete_icon.png" alt="delete" />
            </button> -->
                  <button class="apply-button" @click="selectCardAndGo(card)">折抵</button>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal Component -->
      </div>
    </div>

    <div v-if="showModal" class="offer-card-container">



      <OfferCardModal :visible="showModal" :offer_cards="offer_cards" @close="closeModal"
        @add-card="attempAddToRegisteredCard" />

    </div>

    <div v-if="enterCardNumber">
        <CardNumberModal v-if="enterCardNumber" :selectedOfferCard="selectedOfferCard"
          @go-back-to-select-card="goBackToSelectCard" @card-number-entered="cardNumberEntered"
          @close-modal="closeCardNumberModal" />

      </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OfferCardModal from './OfferCardModal.vue';
import CardNumberModal from './CardNumberModal.vue';
import { getFullImageURL, maskCardNumber } from '@/util/util';

export default {
  // name: 'CardBoard',
  components: {
    OfferCardModal,
    CardNumberModal,
  },
  computed: {
    ...mapGetters(['user', 'registered_cards', 'offer_cards']),
  },
  data() {
    return {

      showSuccess: false,
      showModal: false,
      enterCardNumber: false,
      selectedOfferCard: { bank: '', name: '', card_image: '' },
    };
  },
  methods: {
    ...mapActions(['removeRegisteredCard', 'addToRegisteredCard']), // Assuming you have an action to add a registered card

    getFullImageURL,

    // 卡號遮碼統一走 util 的 maskCardNumber（前六後四），
    // 不再各畫面自己實作，避免遮碼規則不一致
    maskCardNumber,

    capitalizeFirstLetter(str) {
      if (typeof str !== 'string' || str.length === 0) return str;
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    getOfferCardImageURL(offerCardId) {
      const cardImageDict = {};
      this.offer_cards.forEach(card => {
        cardImageDict[card.id] = card.card_image;
      });

      const card_image_path = cardImageDict[offerCardId];
      if (!card_image_path) {
        return getFullImageURL('/images/placeholder.png');
      }

      return getFullImageURL(card_image_path);
    },

    attempRemoveRegisteredCard(cardId, card_type, card_number) {
      card_number = card_number || '**** **** **** ****';
      if (confirm(`Are you sure you want to remove the card ${this.capitalizeFirstLetter(card_type)} ending with ${card_number.slice(-4)}?`)) {
        this.removeRegisteredCard(cardId);
      }
    },

    attempAddToRegisteredCard(offerCard) {

      this.showModal = false;
      this.selectedOfferCard = offerCard;
      this.enterCardNumber = true;

      if (this.enterCardNumber) {
        return;
        // alert('Add to registered card');
        // this.addToRegisteredCard(offerCard);
      }

      const card_number = prompt(`請輸入 ${offerCard.bank} ${offerCard.name} 的卡號`);
      if (!card_number) return;
      if (confirm(`確定要新增卡片 ${offerCard.bank} ${offerCard.name}  ${card_number}?`)) {
        offerCard.card_number = card_number;
        const result = this.addToRegisteredCard(offerCard);
        if (result) {
          alert(`成功新增 ${offerCard.bank} ${offerCard.name} 到您的註冊信用卡。`);
          this.closeModal();
        } else {
          alert('無法新增信用卡。請再試一次。');
        }
      }
    },



    async cardNumberEntered({ key, value, expireDate }) {
      console.log('Card Number Entered:', key, maskCardNumber(value));
      this.selectedOfferCard.card_number = value;
      this.selectedOfferCard.expire_date = expireDate;
      const offerCard = this.selectedOfferCard;
      // this.addToRegisteredCard(this.selectedOfferCard);
      console.log('Offer Card:', { ...offerCard, card_number: maskCardNumber(offerCard.card_number) });

      const result = await this.addToRegisteredCard(offerCard);
      console.log('Add Register Result:', result);
      if (result.success) {
        // alert(`成功新增 ${offerCard.bank} ${offerCard.name} 到您的註冊信用卡。`);
        // this.closeModal();
        this.showSuccess = true;
        // alert(`成功新增 ${offerCard.bank} ${offerCard.name} 到您的註冊信用卡。`);
        // this.closeModal();        
        this.enterCardNumber = false;

      } else {
        alert('無法新增信用卡。請再試一次。');

      }

      // this.addToRegisteredCard({ ...this.selectedOfferCard, [key]: value });
    },

    goBackToSelectCard() {
      this.enterCardNumber = false;
      this.showModal = true;
    },

    closeCardNumberModal() {
      this.enterCardNumber = false;
    },

    openModal() {
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    selectCardAndGo(offerCard) {
      this.$emit('updateState', { key: 'selectedOfferCard', value: offerCard });
      this.$emit('updateState', { key: 'cardNumber', value: offerCard.card_number });
      this.$emit('updateState', { key: 'expireDate', value: offerCard.expire_date });
      this.$emit('registered-card-selected');
    },

    closeRegisteredCardModal() {
      // this.showModal = false;
      this.$emit('cancel-card-select');
    }

  }
};
</script>

<style scoped>
.modal-overlay-login-card-select {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1000;
}

.offer-card-container {

  position: absolute;
  top: 0;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 200;

  /* display: flex; */
  /* flex-direction: column; */
  /* align-items: center; */
  /* justify-content: flex-start; */

  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: white;
  border-radius: 20px;
  margin-top: 20vh;
  width: 640px;
  height: 720px;
  position: relative;
  text-align: center;

}


.dashboard {
  padding: 20px;
  text-align: center;
  /* width:100%; */
  height: 100%;


}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
  color: black;
}


h2 {
  font-size: 24px;
  color: var(--green03);
  font-weight: bold;
  margin-bottom: 8px;
  margin-top: 0px;
}

.subtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}


.card-dashboard {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 10px;
  height: 480px;
  width: 100%;

  margin-left: 10px;

  overflow-y: scroll;
}


.cards-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.add-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;
  border: 2px dashed var(--green03);
  border-radius: 12px;

  cursor: pointer;
  transition: background-color 0.2s;

  width: 576px;
  height: 123px;
  box-sizing: border-box;
}

.add-card:hover {
  background-color: #e6f0ff;
  border-color: var(--green02);
}

.add-icon {
  font-size: 36px;
  color: var(--green03);
}

.add-text {
  margin-left: 12px;
  margin-top: 2px;
  color: var(--green03);


  /* //styleName: md/bold; */
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

}

.registered-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 12px;

  padding: 15px 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;

  width: 576px;
  height: 123px;
  box-sizing: border-box;


  box-sizing: border-box;
}

.registered-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.card-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.card-image {
  width: 120px;
  height: 75px;


  margin-right: 15px;


}

.card-image img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
}

.card-details {
  flex: 1;
  text-align: left;
}

.bank-info {

  /* //styleName: md/bold; */
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  margin: 0;

  color: var(--gray15);
}

.card-number {
  /* //styleName: sm/regular; */
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 21.56px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);

  margin-top: 4px;
  margin-bottom: 4px;

}

.status {
  font-size: 14px;
  color: var(--green03);
  font-weight: bold;
  display: flex;
  align-items: center;

  margin-top: 0px;
  margin-bottom: 0px;
}

.status-icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.delete-button {
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  transition: color 0.2s;
}

.delete-button img {
  width: 24px;
  height: 24px;
}

.delete-button:hover img {
  filter: brightness(0.8);
}

.apply-button {
  /* width: 112px; */
  height: 48px;
  padding: 12px 24px;
  border-radius: 99px;
  border: none;
  color: white;
  background-color: var(--green03);
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  cursor: pointer;




}

.apply-button:hover {
  background-color: var(--green02);
}




/* Responsive Styles for screens smaller than 560px */
@media (max-width: 560px) {

  h2 {
    /* //styleName: xl/bold; */
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-bottom: 37px;


  }


  .modal-content {
    width: 343px;
    height: 480px;
    /* padding: 20px 20px; */
  }

  .add-card,
  .registered-card {
    width: 312px;
    height: 64px;
    border-radius: 8px;
  }

  .card-dashboard {
    height: 300px;
    margin-top: 0px;
    margin-left: 12px;

    width: 330px;

    gap: 12px;
    ;
  }

  .add-card {
    /* height: 100px; */
    padding: 10px;
  }

  .add-icon {
    font-size: 24px;
  }

  .add-text {
    font-size: 14px;
  }

  .registered-card {
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
  }

  .card-content {
    flex-direction: row;
    padding: 0;

  }

  .card-image {
    width: 64px;
    height: 40px;

    margin-right: 6px;
    margin-bottom: 0px;
    /* margin:0p[] */
  }

  .card-details {
    text-align: left;
  }

  .bank-info,
  .card-number,
  .status {
    font-family: Inter;
    font-size: 12px;
    /* font-weight: 700; */
    line-height: 18.48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;


    margin: 0px;
  }

  .delete-button {
    position: static;
    align-self: flex-end;
    margin-top: 10px;
  }

  .status {
    display: none;
  }

  .apply-button {
    /* width: 80px; */
    height: 34px;
    padding: 8px 16px;
    font-size: 12px;
    /* Optional: Adjust font size for better fit */
    line-height: 18.48px;



  }

}
</style>
